import { SearchAgentType } from '../../../tracking/search-results/enums';
import isPropertyManagerFilter from './is-property-manager-filter';

/**
 * Format location profiles into suburb tracking array
 * Formats as: "Suburb Name, State, Postcode"
 */
export const formatSuburbsForTracking = (
  locationProfiles: Array<{
    suburbName?: string | null;
    state?: string | null;
    postcode?: string | null;
  } | null> = [],
): string[] =>
  locationProfiles
    .filter(
      (profile) => profile?.suburbName && profile?.state && profile?.postcode,
    )
    .map(
      (profile) =>
        `${profile?.suburbName}, ${profile?.state}, ${profile?.postcode}`,
    );

export const formatSearchTerm = (
  locationProfiles: Array<{
    suburbName?: string | null;
    state?: string | null;
    postcode?: string | null;
  } | null> = [],
): string =>
  locationProfiles
    .map((profile) =>
      [profile?.suburbName, profile?.state, profile?.postcode]
        .filter(Boolean)
        .join(' '),
    )
    .filter(Boolean)
    .join(', ');

export const formatLocationsForGa4 = (
  locationProfiles: Array<{
    suburbName?: string | null;
    postcode?: string | null;
  } | null> = [],
): { suburbNames: string[]; postcodes: string[] } => {
  const located = locationProfiles.filter(
    (profile): profile is { suburbName: string; postcode: string } =>
      !!profile?.suburbName && !!profile?.postcode,
  );

  return {
    suburbNames: located.map((profile) => profile.suburbName),
    postcodes: located.map((profile) => profile.postcode),
  };
};

/**
 * Get the first suburb name from location profiles
 */
export const getFirstSuburbName = (
  locationProfiles: Array<{
    suburbName?: string | null;
  } | null> = [],
): string | undefined =>
  locationProfiles.find((profile) => !!profile?.suburbName)?.suburbName ??
  undefined;

/**
 * Map agent filter to SearchAgentType enum value
 */
export const mapAgentFilterToEnum = (agentFilter?: string): SearchAgentType =>
  isPropertyManagerFilter(agentFilter)
    ? SearchAgentType.PropertyManager
    : SearchAgentType.SalesAgent;
